<template>
  <div>
    <b-col href="#" class="d-flex justify-content-center pb-3">
      <b-button
        @click="$emit('click')"
        class="btn-hover register"
        variant="outline"
      >
        {{ texto }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  name: "ButtonOutline",
  props: {
    texto: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.register:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  color: #ffffff !important;
  background-color: #5928C2;
}
.btn-hover.register {
  width: 170px;
  height: 42px;
  background-size: 300% 100%;
}
</style>
